import { render, staticRenderFns } from "./AudioCaptureButton.vue?vue&type=template&id=2666b451&scoped=true"
import script from "./AudioCaptureButton.vue?vue&type=script&lang=ts"
export * from "./AudioCaptureButton.vue?vue&type=script&lang=ts"
import style0 from "./AudioCaptureButton.vue?vue&type=style&index=0&id=2666b451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2666b451",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTooltip,QDialog,QCard,QSeparator,QIcon,QCheckbox,QCardActions});
